import React from 'react';

const Skeleton = ({ className = '', ...props }) => {
  return (
    <div 
      className={`animate-pulse rounded bg-muted ${className}`}
      {...props}
    />
  );
};

export { Skeleton };